"use client";

import Link from "next/link";
import { sentryEnv } from "@/libs/sentry-config";

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  if (error && sentryEnv.enabled) {
    void import("@sentry/nextjs").then((Sentry) => Sentry.captureException(error));
  }

  return (
    <section className="relative bg-base-100 text-base-content w-full flex flex-col justify-center gap-8 items-center p-10">
      <div className="p-6 bg-white rounded-xl">
        <img
          src="/assets/images/error.svg"
          alt="Something went wrong illustration"
          width={500}
          height={500}
        />
      </div>
      <h1 className="text-xl md:text-6xl font-semibold">
        Ooops!
      </h1>
      <p className="text-md md:text-lg">
        Uh oh, something went wrong. Try refreshing the page or contact <a href="/dashboard/support" className="text-primary">support</a>
      </p>
      <div className="flex flex-wrap gap-4 justify-center">
        <Link href="/" className="btn btn-outline btn-primary !px-6 !py-3">
          Return to homepage
        </Link>
      </div>
    </section>
  );
}
